<mat-card *ngIf="shouldShow">
    <mat-icon fxFlex="99" fxFlex.gt-sm="3" style="color: red;">warning</mat-icon>
    <div fxFlex="99" fxFlex.gt-sm="50" style="line-height: 1.7;">
        <span class="smallFont" [innerHTML]="translationKey | translate"></span>
    </div>
</mat-card>
